(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["header-drawer"] && !Shopify.designMode) return;
  try {
    class DrawerProductsListing extends HTMLElement {
    connectedCallback() {
      this._swipers = [];
      const drawer = this.closest('#Details-menu-drawer-container');
      const details = this.closest('details');

      this._observer = new MutationObserver((mutations) => {
        const shouldRefresh = mutations.some((m) => m.attributeName === 'open');
        if (shouldRefresh) this._refresh();
      });

      if (drawer) this._observer.observe(drawer, { attributes: true, attributeFilter: ['open'] });
      if (details && details !== drawer)
        this._observer.observe(details, { attributes: true, attributeFilter: ['open'] });

      if (this._isVisible()) this._refresh();
    }

    disconnectedCallback() {
      if (this._observer) this._observer.disconnect();
      clearTimeout(this._initTimer);
      this._destroySwipers();
    }

    _refresh() {
      if (!this._isVisible()) {
        this._destroySwipers();
        return;
      }

      if (this._swipers.length) {
        this._swipers.forEach((swiper) => swiper.update());
        return;
      }

      clearTimeout(this._initTimer);
      this._initTimer = setTimeout(() => this._init(), 120);
    }

    _destroySwipers() {
      this._swipers.forEach((swiper) => swiper.destroy(true, true));
      this._swipers = [];
    }

    _init() {
      if (!this.isConnected) return;
      const sliders = this.querySelectorAll('.ctm-header-drawer-products-swiper');
      if (!sliders.length) return;
      if (!this._isVisible() || Array.from(sliders).some((el) => el.clientWidth < 1)) {
        this._initTimer = setTimeout(() => this._init(), 120);
        return;
      }
      if (typeof Swiper === 'undefined') {
        this._initTimer = setTimeout(() => this._init(), 100);
        return;
      }

      this._swipers = Array.from(sliders).map((el) => {
        return new Swiper(el, {
          slidesPerView: 1.5,
          spaceBetween: 0,
          wrapperClass: 'ctm-header-drawer-products-swiper-wrapper',
          slideClass: 'ctm-header-drawer-products-swiper-slide',
          setWrapperSize: false,
          watchOverflow: true,
          grabCursor: true,
          freeMode: true,
          mousewheel: {
            forceToAxis: true,
          },
        });
      });
    }

    _isVisible() {
      return Boolean(this.offsetWidth || this.offsetHeight || this.getClientRects().length);
    }
  }
  if (!customElements.get('drawer-products-listing')) {
    customElements.define('drawer-products-listing', DrawerProductsListing);
  }
  } catch(e) { console.error(e); }
})();

})();
